import { get as call, post, put } from "$lib/api";
import {currentCustomer} from "$lib/stores/customer";
import Sleep from "$lib/utils/sleep";

let customerUUID:string;
currentCustomer.subscribe(val => {
    if(val && typeof val.uuid !== 'undefined'){
        customerUUID = val.uuid;
    }
})

export const availableAddresses = async ():Promise<any> => {
    if(typeof customerUUID === 'undefined'){
        await Sleep(1000);

    }
    return await call("/address?customerUuid=" + customerUUID);
}
export const getAddress = async (uuid:string):Promise<any> => {
    return await call("/address/" + uuid);
}

export const storeAddress = async (address:any):Promise<any> => {
    address.customerUuid = customerUUID;
    if(typeof address.uuid !== 'undefined'){
        return await put("/address/" + address.uuid, address);
    }
    return await post("/address", address);
}
